import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { app } from '../firebase-config';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import API_BASE_URL from '../utils/apiConfig';
import './FollowersModal.css';

const FollowersModal = ({ userId, type, onClose }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unfollowingId, setUnfollowingId] = useState(null);
  const { currentUser, firebaseUser } = useAuth();
  const db = getFirestore(app);

  const isOwnProfile = currentUser?.uid === userId;

  useEffect(() => {
    const fetchList = async () => {
      setLoading(true);
      try {
        // Query the appropriate subcollection: 'followers' or 'following'
        const subColRef = collection(db, 'users', userId, type);
        const snap = await getDocs(subColRef);
        
        const fetchedUsers = [];
        for (const document of snap.docs) {
          const uId = document.id;
          // Fetch basic details (name) of each user in the list
          const userDoc = await getDoc(doc(db, 'users', uId));
          if (userDoc.exists()) {
            fetchedUsers.push({ id: uId, name: userDoc.data().name || 'User' });
          }
        }
        setList(fetchedUsers);
      } catch (err) {
        console.error("Error fetching list:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchList();
  }, [userId, type, db]);
  // Handle Unfollow Action
  const handleUnfollow = async (targetUserId) => {
    if (!window.confirm("Are you sure you want to unfollow this user?")) return;
    setUnfollowingId(targetUserId);
    try {
      const idToken = await firebaseUser.getIdToken();
      await axios.post(`${API_BASE_URL}/unfollow`, 
        { targetUserId },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      // Remove unfollowed user from local list
      setList(prev => prev.filter(user => user.id !== targetUserId));
    } catch (err) {
      console.error("Error unfollowing user:", err);
      alert("Failed to unfollow user.");
    } finally {
      setUnfollowingId(null);
    }
  };
  
  return (
    <div className="followers-modal-overlay" onClick={onClose}>
      <div className="followers-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="followers-modal-header">
          <h3>{type === 'followers' ? 'Followers' : 'Following'}</h3>
          <button className="close-followers-modal" onClick={onClose}>&times;</button>
        </div>
        <div className="followers-modal-body">
          {loading ? (
            <p className="loading-text">Loading...</p>
          ) : list.length === 0 ? (
            <p className="empty-text">No users found.</p>
          ) : (
            <div className="followers-list">
              {list.map((item) => (
                <div key={item.id} className="follower-item-row">
                  <Link to={`/user/${item.id}`} onClick={onClose} className="follower-name-link">
                    <div className="avatar-placeholder">{item.name.charAt(0).toUpperCase()}</div>
                    <span className="follower-user-name">{item.name}</span>
                  </Link>

                  {/* Show Unfollow button when viewing your own 'following' list */}
                  {isOwnProfile && type === 'following' && (
                    <button 
                      className="unfollow-btn" 
                      onClick={() => handleUnfollow(item.id)}
                      disabled={unfollowingId === item.id}
                    >
                      {unfollowingId === item.id ? 'Unfollowing...' : 'Unfollow'}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowersModal;